import React, { useState, useEffect } from "react";

interface StoryIntroSequenceProps {
  onComplete: () => void;
}

const StoryIntroSequence: React.FC<StoryIntroSequenceProps> = ({
  onComplete,
}) => {
  const [displayedText, setDisplayedText] = useState("");
  const [currentLine, setCurrentLine] = useState(0);
  const [completedLines, setCompletedLines] = useState<string[]>([]);

  // The story text - broken down into separate paragraphs for the typewriter effect
  const storyLines = [
    "The village of Shadowvale lies silent under the moonless night.",
    "For weeks now, the peaceful community has been terrorized by a series of mysterious killings.",
    "Residents whisper of a secret organization - The Mafia - infiltrating their once tranquil home.",
    "Among the villagers, a clever Detective works tirelessly to identify the killers.",
    "A dedicated Doctor attempts to save potential victims before the Mafia strikes again.",
    "Meanwhile, ordinary Villagers live in fear, never knowing who to trust.",
    "As another night falls, everyone knows that morning may reveal yet another victim...",
    "Can you survive the night? Will you discover who's friend and who's foe before it's too late?",
  ];

  // Typewriter effect for current line
  useEffect(() => {
    if (currentLine >= storyLines.length) {
      // All lines finished
      const timer = setTimeout(() => {
        onComplete();
      }, 2000);
      return () => clearTimeout(timer);
    }

    const currentStoryLine = storyLines[currentLine];
    if (displayedText.length < currentStoryLine.length) {
      // Still typing current line
      const timer = setTimeout(() => {
        setDisplayedText(
          currentStoryLine.substring(0, displayedText.length + 1)
        );
      }, 10); // Speed of typing
      return () => clearTimeout(timer);
    } else {
      // Finished typing current line
      const timer = setTimeout(() => {
        setCompletedLines([...completedLines, currentStoryLine]);
        setCurrentLine(currentLine + 1);
        setDisplayedText("");
      }, 500); // Pause between lines
      return () => clearTimeout(timer);
    }
  }, [displayedText, currentLine, completedLines, storyLines, onComplete]);

  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="max-w-2xl p-8">
        {/* Previously completed lines */}
        {completedLines.map((line, index) => (
          <p key={index} className="text-white text-lg mb-3 opacity-80">
            {line}
          </p>
        ))}

        {/* Currently typing line */}
        {currentLine < storyLines.length && (
          <p className="text-white text-lg mb-3">
            {displayedText}
            <span className="animate-pulse">|</span>
          </p>
        )}

        {/* Skip button */}
        <div className="mt-10 text-center">
          <button
            onClick={onComplete}
            className="text-gray-400 hover:text-white text-sm underline"
          >
            Skip Intro
          </button>
        </div>
      </div>
    </div>
  );
};

export default StoryIntroSequence;
